import React from 'react';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';
import { Link, withRouter } from 'react-router-dom';

const RetencionCloneActions = (props) => {
  const { data } = props;

  /**
   * Clasificación 11 timbrado xml no soporta clonar o derivados
   */
  let isStampingXml = data.clasificacion !== 11;

  return (
    <>
      {isStampingXml && Guardian.allows('retencion.clonar.documento') && (
        <>
          <Button
            as={Link}
            variant="secondary"
            to={{
              pathname: '/app/retenciones/timbrado',
              search: `u=${data.uuid}`,
            }}
            className="text-muted mr-2"
          >
            Clonar
          </Button>
        </>
      )}
    </>
  );
};

export default withRouter(RetencionCloneActions);
